"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
var _templateObject, _class, _FlagGlIcon;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  display: inline-block;\n  overflow: hidden;\n  width: ", ";\n  height: ", ";\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.width;
});
var FlagGlIcon = (0, _mobxReact.observer)(_class = (_FlagGlIcon = /*#__PURE__*/function (_React$Component) {
  function FlagGlIcon() {
    _classCallCheck(this, FlagGlIcon);
    return _callSuper(this, FlagGlIcon, arguments);
  }
  _inherits(FlagGlIcon, _React$Component);
  return _createClass(FlagGlIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        width: this.props.width
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100"
      }, /*#__PURE__*/_react["default"].createElement("g", {
        fill: "none"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#FFF",
        d: "M0 0h100v100H0z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#1DB5D7",
        d: "M0 0v13.5L86.5 100H100V83.7L16.3 0z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M51.2 72.3h-2.5c-8.9 0-16.1-7.2-16.1-16.1V27.7h34.7v28.5c0 8.9-7.2 16.1-16.1 16.1z",
        fill: "#1DB5D7"
      }), /*#__PURE__*/_react["default"].createElement("g", {
        transform: "translate(36 30)"
      }, /*#__PURE__*/_react["default"].createElement("ellipse", {
        fill: "#FFF",
        cx: "14",
        cy: "12",
        rx: "3.4",
        ry: "3.7"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#FFF",
        d: "M6.4 26H4.3v-2.1H2.7V26h-2v1.6h2v2h1.6v-2h2.1zM27.4 26h-2v-2.1h-1.6V26h-2.1v1.6h2.1v2h1.6v-2h2zM6.4 15.3H4.3v-2H2.7v2h-2v1.6h2V19h1.6v-2.1h2.1zM27.4 15.3h-2v-2h-1.6v2h-2.1v1.6h2.1V19h1.6v-2.1h2zM6.4 4.7H4.3v-2H2.7v2h-2v1.6h2v2.1h1.6V6.3h2.1zM27.4 4.7h-2v-2h-1.6v2h-2.1v1.6h2.1v2.1h1.6V6.3h2zM16.7 2.7h-2.1V.6H13v2.1h-2.1v1.6H13v2.1h1.6V4.3h2.1z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M15.1 28.9v-.6c.6-.6 1.1-1.6 1.1-2.8 0-1-.3-1.8-.8-2.5 2.5-.6 4.3-2.8 4.3-5.3 0-.5-.1-.9-.2-1.4H8.4c-.1.4-.2.9-.2 1.4 0 2.5 1.8 4.6 4.2 5.3-.5.6-.8 1.5-.8 2.5 0 1.3.5 2.3 1.2 2.9v.3c0 4.5-2 8.2-4.7 8.8H19c-2.2-1.1-3.9-4.5-3.9-8.6z",
        fill: "#E9C102"
      })))));
    }
  }]);
}(_react["default"].Component), _FlagGlIcon.defaultProps = {
  width: '20px'
}, _FlagGlIcon)) || _class;
var _default = exports["default"] = (0, _icon_wrapper["default"])(FlagGlIcon);